import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  Link,
} from "@mui/material";
import {
  LastBillsTableRow,
  LastBillsTableColumn,
} from "../../../core/models/lastBills/lastBills.model";
import SuppliesBillsStateContent from "../../SuppliesBillsStateContent/SuppliesBillsStateContent";
import "./LastBillsTable.scss";
import { useTranslation } from "react-i18next";
import EnvirormentContent from "../../EnvirormentContent/EnvirormentContent";
import LoadingComponentComponent from "../../UI/LoadingComponentComponent/LoadingComponentComponent";
import { useEffect, useState } from "react";

export interface LastBillsTableProps {
  lastBillsTableRows: LastBillsTableRow[];
  handleClickDonwloadBill: (id: string) => Promise<void>;
  isDownloadLoading: boolean;
}

const LastBillsTable = ({
  lastBillsTableRows,
  handleClickDonwloadBill,
  isDownloadLoading,
}: LastBillsTableProps) => {
  const { t } = useTranslation();
  const [rowId, setRowId] = useState<string[]>([]);
  useEffect(() => {
    if (!isDownloadLoading) {
      setRowId([]);
    }
  }, [isDownloadLoading]);

  const lastBillsTableColumns: LastBillsTableColumn[] = [
    {
      id: "service",
      label: "Servicio",
      align: "left",
      width: "10%",
      cellContent: (row) => (
        <EnvirormentContent service={row.service} variant={"body1"} />
      ),
    },
    {
      id: "billDate",
      label: "Fecha de emisión",
      align: "left",
      width: "20%",
    },
    {
      id: "period",
      label: "Periodo",
      align: "left",
      width: "25%",
    },
    {
      id: "amount",
      label: "Importe",
      align: "left",
      width: "20%",
      fontWeight: 600,
    },
    {
      id: "state",
      label: "Estado",
      align: "left",
      width: "30%",
      cellContent: (row) => <SuppliesBillsStateContent state={row.state} />,
    },
  ];

  return (
    <Box component="article" className="last-bills-table">
      <TableContainer sx={{ overflow: "visible" }}>
        <Table>
          <TableHead>
            <TableRow>
              {lastBillsTableColumns.map(({ id, align, width, label }) => (
                <TableCell key={id} align={align} width={width}>
                  {!!label.length && (
                    <Typography variant="subtitle2" sx={{ color: "grey.700" }}>
                      {t(`Tablas.${label}`)}
                    </Typography>
                  )}
                </TableCell>
              ))}
              <TableCell align="left" width="25%" />
            </TableRow>
          </TableHead>
          <TableBody>
            {lastBillsTableRows.map((row) => (
              <TableRow key={`${row.id}}`} sx={{ position: "relative" }}>
                {lastBillsTableColumns.map(
                  (
                    { id, width, align, cellContent, fontWeight },
                    indexNumber
                  ) => {
                    const cellValue = row[id];
                    return (
                      <TableCell
                        key={`${row.id}_${id}_${indexNumber}}`}
                        align={align}
                        width={width}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: fontWeight,
                            lineHeight: "16px",
                          }}
                        >
                          {cellContent ? cellContent(row) : cellValue}
                        </Typography>
                      </TableCell>
                    );
                  }
                )}
                <TableCell align="left" width="25%">
                  <Link
                    component="button"
                    underline="none"
                    onClick={() => {
                      handleClickDonwloadBill(row.id);
                      setRowId((prevRowId) => [...prevRowId, row.id]);
                    }}
                    sx={{ float: "right" }}
                  >
                    <Typography
                      component="span"
                      aria-hidden="true"
                      className="t-icon-download"
                      sx={{ paddingRight: "10px" }}
                    />{" "}
                    {t("Facturas Página.Descargar factura")}
                  </Link>
                </TableCell>
                {isDownloadLoading && rowId.includes(row.id) && (
                  <TableCell sx={{ display: "contents" }}>
                    <LoadingComponentComponent
                      isLoading={isDownloadLoading}
                      opacity={0.5}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LastBillsTable;
